import React from "react";
import { Link } from "react-router-dom";
import Lottie from "lottie-react";
import phonepeAnimation from "../assets/phonepe.json"

const Footer = () => {
  return (
   <footer className="py-lg-8 py-5 footer-section pb-5 mb-5">
  <div className="container">
    <div className="row gy-4 gy-lg-5">
      <div className="col-lg-4 col-12">
        <div className="d-flex flex-column gap-4">
         
         <div className="d-flex flex-column gap-4">
  <div></div>
  <div className="p-3 rounded-3 border" 
       style={{ 
         background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
         color: 'white' 
       }}>
    
    <h6 className="fw-bold mb-2 fs-5">GENZELITE</h6>
    <p className="mb-3 small lh-sm">
      <strong className="d-block fs-6 fw-bolder mb-1 text-warning">
        END-TO-END DIGITAL SOLUTIONS
      </strong>
      <span>IDEA → DESIGN → CODE → LAUNCH → SCALE</span>
    </p>
    
   <div className="d-flex gap-2 flex-wrap">
  <a href="mailto:elitezgen@gmail.com" className="btn btn-light btn-sm px-3 py-1 d-flex align-items-center gap-1">
    <i className="fab fa-google"></i>
    Mail
  </a>
 <a href="https://wa.me/918838817110" className="btn btn-success btn-sm px-3 py-1 d-flex align-items-center gap-1">
  <i className="fab fa-whatsapp"></i>
  WhatsApp
</a>

  <a href="https://www.instagram.com/genelitez?igsh=MW40dTFmenA3eDVuNw==" className="btn btn-outline-light btn-sm px-3 py-1 border-0 d-flex align-items-center gap-1">
    <i className="fab fa-instagram"></i>
    Instagram
  </a>
</div>
       
    
    <small className="d-block mt-2 opacity-90 fw-semibold">
     CUSTOM DIGITAL PLATFORMS FOR ALL BUSINESSES
    </small>
  </div>
</div>

        </div>
      </div>

      <div className="col-lg-2 col-md-3 col-6">
        <div className="d-flex flex-column gap-2">
          <h5 className="fw-bold text-white text-uppercase mb-0">
            bsk boutique
          </h5>
          <ul className="footer-collection list-unstyled">
            <li>
              <Link to="/bsk-about" className="nav-link text-light">
                About
              </Link>
            </li>
            <li>
              <Link to="/bsk-shipping" className="nav-link text-light">
                Shipping
              </Link>
            </li>
            <li>
              <Link to="/bsk-contact-us" className="nav-link text-light">
                Contact us
              </Link>
            </li>
            <li>
              <Link to="/bsk-fag" className="nav-link text-light">
                FAQ
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="col-lg-2 col-md-3 col-6">
        <div className="d-flex flex-column gap-2">
          <h5 className="fw-bold text-white text-uppercase mb-0">
            Support
          </h5>
          <ul className="footer-collection list-unstyled">
            <li>
              <Link to="/bsk-cancel-refund" className="nav-link text-light">
                Refund & Cancellation
              </Link>
            </li>
            <li>
              <Link to="/bsk-terms-condition" className="nav-link text-light">
                Terms & Conditions
              </Link>
            </li>
            <li>
              <Link to="/bsk-privacy-policy" className="nav-link text-light">
                Privacy policy
              </Link>
            </li>
            <li>
              <Link to="/bsk-size-chart" className="nav-link text-light">
                Size Chart
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="col-lg-2 col-md-3 col-6">
        <div className="d-flex flex-column gap-2">
          <h5 className="fw-bold text-white text-uppercase mb-0">
            Follow us
          </h5>
          <ul className="d-flex p-0 mt-3 gap-3 flex-wrap list-unstyled m-0">
            <a
              className="insta-icon text-decoration-none"
              href="https://www.instagram.com/bskboutique?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
              target="_blank"
              rel="noreferrer"
            >
              <i className="fa-brands fa-instagram icon-footer fs-5"></i>
            </a>
            <a
              className="whatsapp-icon text-decoration-none"
              href="https://wa.me/8668160894"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fa-brands fa-whatsapp icon-footer fs-5"></i>
            </a>
          </ul>
        </div>
      </div>

      <div className="col-lg-2 col-md-3 col-6">
        <div className="d-flex flex-column gap-2">
          <h5 className="fw-bold text-white text-uppercase mb-0">
            payment
          </h5>
          <div>
            <p className="text-light mb-2" style={{ fontSize: "14px" }}>
              Secure and fast payments powered by PhonePe.
            </p>
            <div style={{ width: "100px", height: "40px" }}>
              <Lottie animationData={phonepeAnimation} loop />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="row mt-lg-5 mt-5">
      <div className="col-12 text-center text-white">
        <span className="d-block d-lg-flex justify-content-center align-items-center gap-2">
          ©
          <span id="copyright2" className="me-0">
            {new Date().getFullYear()}
          </span>
           <span className="ps-2">BSK Boutique. All Rights Reserved.</span> 
        </span>
      </div>
    </div>
  </div>
</footer>

  );
};

export default Footer;
